import { useParams } from "react-router-dom";

// The current patient id is the URL path param (/patients/:patientId/...).
// The URL is the single source of truth — no localStorage, no Redux — so the id
// is always correct for the page on screen and each browser tab is independent.
// Returns undefined when rendered outside a patient route (no current patient).
export const useCurrentPatientId = () => {
  const { patientId } = useParams();

  return patientId;
};
